// US-090: ordering for the Create-PO product table.
//
// The page shows one table, not two: the products already on the PO are pinned to the
// top, and the browsable reorder-suggestion catalog continues below them. That way a
// product added through the Add Products search dialog is visible immediately — even
// though it usually isn't on the catalog's current server-paginated page — without
// duplicating the table's ~20 column slots into a second component.
//
// The pinned row object is the one held in the component's selectionMap, so quantity
// and cost edits made in the pinned block are the same object the Order Summary,
// submitPurchaseOrder() and the catalog's checkbox state already read.

/**
 * Return the selected (on-PO) rows first, then the catalog rows that aren't already
 * pinned. Variant ids are compared numerically because Phase-1 and report rows disagree
 * on whether variant_id is a string or a number.
 */
export function pinSelectedFirst(
  selectedRows: any[],
  catalogRows: any[],
  pinnedIds?: { has(id: number): boolean },
): any[] {
  if (!selectedRows.length) { return catalogRows; }
  // Callers that already hold a Map/Set keyed by Number(variant_id) (the component's
  // selectionMap) pass it in rather than making this rebuild one per recompute.
  const ids = pinnedIds
    || new Set<number>(selectedRows.map((r: any) => Number(r.variant_id)));
  return [
    ...selectedRows,
    ...catalogRows.filter((r: any) => !ids.has(Number(r.variant_id))),
  ];
}
